import { VariantProps, cva } from 'class-variance-authority';
import { ComponentProps } from 'react';
import { Typography } from '../typography/typography';
import { match } from 'ts-pattern';

export const dropdownSelectedValueStyles = cva([''], {
  variants: {
    size: {
      small: [],
      default: [],
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export type DropdownSelectedValueStyles = VariantProps<
  typeof dropdownSelectedValueStyles
>;

export function mapSizeToTypographyVariant(
  size: DropdownSelectedValueStyles['size'],
): ComponentProps<typeof Typography>['variant'] {
  return match(size)
    .returnType<ComponentProps<typeof Typography>['variant']>()
    .with('small', () => 'body-xs')
    .with('default', () => 'body-m')
    .otherwise(() => 'body-xs');
}
